module.exports = __webpack_public_path__ + "media/exploreServices/photography-cc1e0a1f.png";